
        module.exports = __webpack_public_path__ + "assets/images/EF_logo.f2061031.png";;

        var src = '' + module.exports;

        module.exports = {

            src: src,
            width: 1790,
            height: 566,
            type: "png",
            bytes: 70997,

            toString: function() {
                return src;
            }
        };
    